import { useAddProductToWishlistMutation } from '@/account/api/mutation/add-product-to-wishlist';
import { useAddToast } from '@/components/base/toast/use-toast';
import { CallbackActions } from '@/features/login/components/login/log-in-with-email';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';

export const useLoginCallbacks = () => {
  const searchParams = useSearchParams();
  const paramsObject = Object.fromEntries(searchParams.entries());
  const keysParams = Object.keys(paramsObject);
  const t = useTranslations('common');
  const { mutateAsync } = useAddProductToWishlistMutation();
  const addToast = useAddToast();
  const loginCallback = async () => {
    switch (true) {
      case keysParams.includes(CallbackActions.ADD_TO_FAVORITE):
        try {
          await mutateAsync({
            productId: paramsObject[CallbackActions.ADD_TO_FAVORITE],
          });
          addToast({ content: t('add_to_favorites_success'), type: 'success' });
        } catch {
          //
        }
        break;
    }
  };

  return { loginCallback };
};
